import { Box, Button, DialogActions, Typography } from '@mui/material';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import React from 'react';
import { Manager } from '../../models/manager';
import { Talent } from '../../models/talent';
import DefaultModal from './DefaultModal';

interface Props {
  modalData: { open: boolean; user?: Manager[] | Talent[] };
  closeModal: () => void;
  confirmModal: () => void;
}

const LoginAsModal = ({
  modalData,
  closeModal,
  confirmModal
}: Props): JSX.Element => {
  return (
    <DefaultModal open={modalData.open} handleClose={closeModal}>
      <Box sx={{ textAlign: 'center', px: 6 }}>
        <SwitchAccountIcon
          color={'primary'}
          sx={{ fontSize: '60px', marginBottom: '20px' }}
        />
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Login as User?
        </Typography>

        <Typography textAlign="center" mb={1}>
          Your about to login as&nbsp;
          <strong>
            {modalData?.user &&
              `${modalData?.user[0]?.firstName} ${modalData?.user[0]?.lastName}`}
          </strong>
          &nbsp;on his AllWork account, and you will be logged out of your
          current session.
        </Typography>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={closeModal}>
          Cancel
        </Button>
        <Button onClick={confirmModal}>Login As User</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default LoginAsModal;
